import http from "./http";

function saveDeviceInstallationData(data) {
  return http.post(`addVehicle`, data);
}

function get_device_list_for_agency(data) {
  return http.post(`Device_ForInstallation`, data);
}

function getvehicle_category_for_agency(data) {
  return http.post(`vehicle_List`, data);
}

function getvehicle_wheel_for_agency(data) {
  return http.post(`vehicleWheelList`, data);
}

function fetchRemainingVehicleData(data) {
  return http.post(`vehicleListforInstallation`, data);
}

function save_device_allotment(data) {
  return http.post(`deviceInstallation`, data);
}

function add_and_update_device_from_profile(data) {
  return http.post(`deviceAssignTo_vehicle`, data);
}

function remove_device_from_profile(data) {
  return http.post(`deviceRemoveTo_vehicle`, data);
}

const DeviceInstallationSerive = {
  saveDeviceInstallationData,
  get_device_list_for_agency,
  getvehicle_category_for_agency,
  getvehicle_wheel_for_agency,
  fetchRemainingVehicleData,
  save_device_allotment,
  add_and_update_device_from_profile,
  remove_device_from_profile,
};

export default DeviceInstallationSerive;
